import React, { useEffect, useState } from 'react';
import {
  Button,
  Drawer,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  Checkbox,
} from '@mui/material';
import controller from '../../../../assets/images/controller.svg';
import controllerActive from '../../../../assets/images/conroller_active.svg';
import emptyFolter from '../../../../assets/images/empty-folder 2.svg';
import createPopoverimg from '../../../../assets/images/createControllerPopover.svg';
import { useNavigate } from 'react-router-dom';
import ControllerNameEdit from './controllerNameEdit';
import { useHook as ControllerHook } from './useHook';
import { useHook as RoleHook } from '../../Iam/rolemanagement/useHook';
import { useSelector } from 'react-redux';
import ControllerParamForm from './controllerParameterForm';
import { Unauthorized } from '../../../../components/index';
import { ErrorMessage } from '../../../../permissionErrorMessage/PermissionMessage';
interface Role {
  roleID: string | number;
  roleName?: string;
}
interface Props {
  pagePermissionIDs: unknown;
}
const CreateController: React.FC<Props> = ({ pagePermissionIDs }) => {
  const canRolelistPermission =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('roles::list');

  const requiredAccess = (
    <section className="required_access_section">
      <p>you require below access:</p>
      <ul>
        <li>{ErrorMessage['roles::list'] || ''}</li>
      </ul>
    </section>
  );
  const navigate = useNavigate();
  const { createController } = ControllerHook();
  const { allRole } = useSelector((state: any) => state.role);
  const { fetchGetAllRoleList } = RoleHook();
  const [controllerPage, setControllerPage] = useState('basicDetails');
  const [croppedImage, setCroppedImages] = useState<string | null>(null);
  const [createPopover, setCreatePopover] = useState(false);
  const [controllerPayload, setControllerPayload]: any = useState(null);
  const [paramsPayload, setParamsPayload]: any = useState([]);
  const [editIndex, setEditIndex] = useState<number | null>(null);
  const [open, setOpen] = React.useState(false);
  const [formData, setFormData] = useState({
    name: '',
    type: '',
    variableName: '',
    behaviour: '',
    customerAccess: false,
    comment: '',
  });

  const submitParam = (data: any) => {
    const parameters = [
      {
        name: data?.name,
        type: data?.type,
        variableName: data?.variableName?.replace(/\s/g, ''),
        behaviour: data?.behaviour ? data?.behaviour : 'READ',
        accessPermissions: data?.accessPermissions,
        customerAccess: data?.customerAccess,
        comment: data?.comment,
      },
    ];
    if (!(editIndex === null)) {
      const updatedItems = [...paramsPayload];
      updatedItems[editIndex] = {
        name: data?.name,
        type: data?.type,
        variableName: data?.variableName?.replace(/\s/g, ''),
        behaviour: data?.behaviour ? data?.behaviour : 'READ',
        accessPermissions: data?.accessPermissions,
        customerAccess: data?.customerAccess,
        comment: data?.comment,
      };
      setParamsPayload(updatedItems);
      setEditIndex(null);
    } else {
      setParamsPayload((prev: any) => [...prev, ...parameters]);
    }

    setFormData({
      name: '',
      type: '',
      variableName: '',
      behaviour: '',
      customerAccess: false,
      comment: '',
    });
    setOpen(false);
  };

  const submitdata = (data: any) => {
    const controllerPayload = {
      controllerName: data?.name,
      model: data?.model,
    };
    setControllerPayload(controllerPayload);

    controllerPage === 'basicDetails'
      ? setControllerPage('specifyParameters')
      : setControllerPage('basicDetails');
  };

  const handleCreateController = async () => {
    const imageType = croppedImage?.substring(11, croppedImage?.indexOf(';'));
    const imageWithoutPrefix = croppedImage?.substring(
      croppedImage?.indexOf(',') + 1,
    );
    const payload = {
      controllerName: controllerPayload?.controllerName,
      model: controllerPayload?.model,
      image: imageWithoutPrefix ? imageWithoutPrefix : '',
      ext: imageType ? imageType : '',
      parameters: paramsPayload,
    };
    await createController(payload);

    setCreatePopover(false);
  };

  useEffect(() => {
    if (!(allRole?.length > 0)) {
      fetchGetAllRoleList({});
    }
  }, []);

  const findrolename = (roleid: string) => {
    if (allRole?.length > 0) {
      if (roleid) {
        const findrole = allRole.find((param: Role) => param.roleID == roleid);
        return findrole?.roleName ? findrole?.roleName : roleid;
      } else {
        return roleid;
      }
    } else {
      return roleid;
    }
  };
  const handleParamEdit = (editIndex: number) => {
    setEditIndex(editIndex);
    const EditData = paramsPayload[editIndex];
    setFormData(EditData);
    setOpen(true);
  };

  const handleParamDelete = (deleteIndex: number) => {
    const updatedItems = [...paramsPayload];
    updatedItems.splice(deleteIndex, 1);
    setParamsPayload(updatedItems);
  };

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
    setFormData({
      name: '',
      type: '',
      variableName: '',
      behaviour: '',
      customerAccess: false,
      comment: '',
    });
    if (newOpen === false) {
      setEditIndex(null);
    }
  };

  return (
    <>
      {!canRolelistPermission ? (
        <Unauthorized requiredAccess={requiredAccess} />
      ) : (
        <>
          <div className="create_controller_header">
            <Button
              className={
                controllerPage === 'basicDetails'
                  ? 'create_controller_header controller-active'
                  : 'create_controller_header'
              }
              onClick={() => setControllerPage('basicDetails')}
            >
              <img
                src={
                  controllerPage === 'basicDetails'
                    ? controllerActive
                    : controller
                }
                width={40}
                alt="User Profile"
              />{' '}
              <p>Basic Details</p>
            </Button>
            <div className="create_controller_header-line"></div>
            <div
              className={
                !(controllerPage === 'basicDetails')
                  ? 'create_controller_header controller-active'
                  : 'create_controller_header'
              }
            >
              <img
                src={
                  !(controllerPage === 'basicDetails')
                    ? controllerActive
                    : controller
                }
                width={40}
                alt="User Profile"
              />{' '}
              <p>Specify Parameters</p>
            </div>
          </div>

          {controllerPage === 'basicDetails' ? (
            <ControllerNameEdit
              handleCreateSubmit={submitdata}
              setCreateCroppedImages={setCroppedImages}
            />
          ) : (
            <div className="create_controller_form create_controller_table">
              <TableContainer className="controller_table" component={Paper}>
                <Table
                  className={
                    paramsPayload?.length > 0
                      ? 'fullwidthcontroller_table'
                      : 'nodatacontroller_table'
                  }
                >
                  <TableHead className="controller_tableheader">
                    <TableRow>
                      <TableCell>Names</TableCell>
                      <TableCell>Type</TableCell>
                      <TableCell>Variable Name</TableCell>
                      <TableCell>Behaviour</TableCell>
                      <TableCell>Access Permission</TableCell>
                      <TableCell>Customer Access</TableCell>
                      <TableCell>Comment</TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paramsPayload.length > 0 ? (
                      paramsPayload.map((controller: any, index: number) => (
                        <TableRow key={index}>
                          <TableCell className="controller_management_name">
                            <div className="controller_management_name-data">
                              <p>{controller.name}</p>
                            </div>
                          </TableCell>
                          <TableCell className="controller_management_type">
                            <p className="controller_management_model-data">
                              {controller.type}
                            </p>
                          </TableCell>
                          <TableCell className="controller_management_variable">
                            <p className="controller_management_model-data">
                              {controller.variableName}
                            </p>
                          </TableCell>
                          <TableCell className="controller_management_behaviour">
                            <p className="controller_management_model-data">
                              {controller.behaviour
                                ? controller.behaviour
                                : 'READ'}
                            </p>
                          </TableCell>
                          <TableCell className="controller_management_permission">
                            <div>
                              {controller.accessPermissions &&
                                controller.accessPermissions?.map(
                                  (Permission: string, index: number) => (
                                    <div
                                      key={index}
                                      className="controller_permission-data"
                                    >
                                      <Typography variant="body1">
                                        {findrolename(Permission)}
                                      </Typography>
                                    </div>
                                  ),
                                )}
                            </div>
                          </TableCell>
                          <TableCell className="controller_management_access">
                            <Checkbox
                              checked={controller.customerAccess}
                              disabled={true}
                            />
                          </TableCell>
                          <TableCell className="controller_management_comment">
                            <p className="controller_management_model-data">
                              {controller.comment}
                            </p>
                          </TableCell>
                          <TableCell className="controller_management_icons-data">
                            <div className="form-action-btn">
                              <Button
                                className="btn-transparent border-0 img-background-form"
                                onClick={() => handleParamEdit(index)}
                              >
                                <i className="edit-icon bi bi-pencil-square bi-lg"></i>
                              </Button>
                              <Button
                                className="btn-transparent border-0 img-background-form"
                                onClick={() => handleParamDelete(index)}
                              >
                                <i className="delete-icon bi bi-trash3-fill bi-lg"></i>
                              </Button>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <></>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              {paramsPayload?.length > 0 && (
                <div className="create_controller-addparameter">
                  <Button onClick={toggleDrawer(true)}>+ Add Parameter</Button>
                </div>
              )}
              {!(paramsPayload?.length > 0) && (
                <div className="create_controller-nodata">
                  <img
                    src={emptyFolter}
                    alt="nodata"
                    width="120"
                    height="120"
                  />
                  <h3>No Record Found!</h3>
                  <Button onClick={toggleDrawer(true)}>Add Parameter</Button>
                </div>
              )}

              <Drawer open={open} anchor="right" onClose={toggleDrawer(false)}>
                <ControllerParamForm
                  paramCloseDrawer={toggleDrawer(false)}
                  paramSubmit={submitParam}
                  formEditData={formData}
                />
              </Drawer>

              <div className="create_controller_form-submit create_controller_table-submit">
                <Button
                  onClick={() => navigate('/hardware/controller')}
                  className="create_controller_form-cancel-btn"
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => setCreatePopover(true)}
                  className="create_controller_form-submit-btn"
                >
                  Create controller
                </Button>
              </div>
            </div>
          )}

          <Dialog
            className="popup"
            open={createPopover}
            onClose={() => setCreatePopover(false)}
            aria-labelledby="delete-dialog-title"
            aria-describedby="delete-dialog-description"
          >
            <DialogContent className="controller_popover">
              <DialogContentText
                className="text-center"
                id="delete-dialog-description"
              >
                <img src={createPopoverimg} alt="createPopover" />
                <h4>Are you sure?</h4>
                <p>
                  Once a controller is created youll be able to edit only access
                  permissions.
                </p>
                <p>Any other properties of Parameters wont be editable. </p>
              </DialogContentText>
            </DialogContent>
            <DialogActions className="controller_popover-action">
              <Button
                onClick={() => setCreatePopover(false)}
                variant="contained"
                className="controller_popover-cancel-btn"
              >
                Cancel
              </Button>
              <Button
                onClick={handleCreateController}
                variant="contained"
                className="controller_popover-create-btn"
              >
                create
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}
    </>
  );
};

export default CreateController;
